/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementEditEventResponse } from './EventManagementEditEventResponse';

export type EventManagementEditEventResponseApiRespoonse = {
    data?: EventManagementEditEventResponse;
    status?: EventManagementEditEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementEditEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

